module.exports = __webpack_public_path__ + "static/media/9-3.2385064f.svg";